class CrossSellManager {
  constructor() {
    this.isInitialized = false;
    this.init();
    this.cartModal = document.querySelector('cart-drawer');
  }

  init() {
    if (!this.isInitialized) {
      this.bindEvents();
      this.initDragScroll();
      this.isInitialized = true;
    }
  }

  bindEvents() {
    // Listen for apply bundle upsell button clicks in popup - use event delegation
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-action="apply-bundle-upsell"]')) {
        e.preventDefault();
        this.handleBundleUpsellApply(e.target);
      }
    });

    // Listen for cross-sell ATC button clicks - use event delegation
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-cross-sell-atc]')) {
        e.preventDefault();
        this.handleCrossSellAdd(e.target);
      }
    });
  }

  async handleBundleUpsellApply(button) {
    try {
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Loading...';

      const originalItemKey = button.dataset.originalItemKey;

      if (!originalItemKey) {
        throw new Error('cart item not found');
      }

      // Get selected bundle items from popup
      const bundleItem = this.prepareBundleItemFromPopup(button);

      if (!bundleItem) {
        throw new Error('Failed to prepare bundle item');
      }

      console.log('Bundle item prepared:', bundleItem);

      // Remove original item and add bundle
      await this.replaceCartItems(originalItemKey, bundleItem);

      // Close the popup
      this.closePopup(button);

      // Hide the upsell section
      this.hideUpsellSection(button);

    } catch (error) {
      console.error('Error replacing with bundle:', error);
      button.disabled = false;
      button.textContent = button.textContent.includes('Loading') ?
        document.querySelector('.bundle-upsell-popup__apply-btn')?.textContent || 'Anwenden' :
        button.textContent;
    }
  }

  prepareBundleItemFromPopup(button) {
    const variantId = button.dataset.bundleVariantId;
    const bundleProductName = button.dataset.name;
    const setId = button.dataset.setId;
    const originalItemKey = button.dataset.originalItemKey;

    if (!variantId) {
      throw new Error('bundle variant id not found');
    }

    // Get all selected bundle items from the popup
    const popup = button.closest('.bundle-upsell-popup__content');
    if (!popup) {
      throw new Error('popup not found');
    }

    const selectedItems = popup.querySelectorAll('.bundle-upsell-popup__item');
    const bundleItemsIds = [];
    const bundleItemsHandles = [];

    selectedItems.forEach(item => {
      const productId = item.dataset.productId;
      const productHandle = item.dataset.productHandle;

      if (productId && productHandle) {
        bundleItemsIds.push(parseInt(productId));
        bundleItemsHandles.push(productHandle);
      }
    });

    if (bundleItemsIds.length === 0) {
      throw new Error('No bundle items selected');
    }

    const bundleItem = {
      id: parseInt(variantId),
      quantity: 1,
      properties: {
        "_setId": setId,
        "_upsell": true
      }
    };

    // Add bundle component properties
    bundleItem.properties['_includeItem'] = bundleItemsIds.join(',');
    bundleItem.properties['_includeItemHandles'] = bundleItemsHandles.join(',');

    if (bundleProductName) {
      bundleItem.properties['_bundle_set_title'] = bundleProductName;
    }

    return bundleItem;
  }

  async replaceCartItems(originalItemKey, bundleItem) {
    // First remove the original item
    const removeResponse = await fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        id: originalItemKey,
        quantity: 0
      })
    });

    if (!removeResponse.ok) {
      throw new Error('Failed to remove original item');
    }

    // Then add the bundle item using same pattern as product-bundle-set.js
    const body = JSON.stringify({
      items: [bundleItem],
      sections: this.cartModal?.getSectionsToRender().map(section => section.id).join(','),
      sections_url: window.location.pathname
    });

    const addResponse = await fetch(`${routes.cart_add_url}`, {...fetchConfig(),...{ body }});

    if (!addResponse.ok) {
      throw new Error('Failed to add bundle item');
    }

    const response = await addResponse.json();

    if (this.cartModal) {
      this.cartModal.renderContents(response, false);
    }

    return response;
  }

  closePopup(button) {
    const popup = button.closest('modal-dialog');
    if (popup && typeof popup.hide === 'function') {
      popup.hide();
    }
  }

  hideUpsellSection(button) {
    // Find upsell section by original item key
    const originalItemKey = button.dataset.originalItemKey;
    if (originalItemKey) {
      const upsellButton = document.querySelector(`[data-action="open-bundle-upsell-popup"][data-original-item-key="${originalItemKey}"]`);
      if (upsellButton) {
        const upsellSection = upsellButton.closest('.cart-upsell-section');
        if (upsellSection) {
          upsellSection.style.display = 'none';
        }
      }
    }
  }

  async handleCrossSellAdd(button) {
    try {
      button.disabled = true;
      button.textContent = 'Loading...';

      const variantId = button.dataset.variantId;

      if (!variantId) {
        throw new Error('Variant ID not found');
      }

      // Check if this is a bundle product
      const isBundle = button.dataset.type === 'bundle';

      const discountData = {
        discountPercentage: button.dataset.discountPercentage
      };

      if (isBundle) {
        // Handle bundle product addition
        await this.addCrossSellBundle(button, discountData);
      } else {
        // Handle regular product addition
        await this.addCrossSellProduct(variantId, discountData);
      }

    } catch (error) {
      console.error('Error adding cross-sell product:', error);
    } finally {
      button.textContent = button.getAttribute('data-original-text');
      button.disabled = false;
    }
  }

  async addCrossSellProduct(variantId, discountData = {}) {
    // Prepare line item properties
    const properties = {
      "_Upsell": true
    };

    // Add discount properties if available
    if (discountData.discountPercentage) {
      properties["_cross_sell_discount_percentage"] = discountData.discountPercentage;
    }

    const body = JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1,
        properties: properties
      }],
      sections: this.cartModal?.getSectionsToRender().map(section => section.id).join(','),
      sections_url: window.location.pathname
    });

    const response = await fetch(`${routes.cart_add_url}`, {...fetchConfig(),...{ body }});

    if (!response.ok) {
      throw new Error('Failed to add cross-sell product');
    }

    const responseData = await response.json();

    if (this.cartModal) {
      this.cartModal.renderContents(responseData, false);
    }

    return responseData;
  }

  async addCrossSellBundle(button, discountData = {}) {
    const variantId = button.dataset.variantId;
    const setId = button.dataset.setId;
    const bundleName = button.dataset.bundleName;
    const bundleComponentIds = button.dataset.bundleComponentIds;
    const bundleComponentHandles = button.dataset.bundleComponentHandles;

    if (!variantId || !setId || !bundleComponentIds || !bundleComponentHandles) {
      throw new Error('Missing bundle data');
    }

    // Prepare bundle item similar to product-bundle-set.js
    const bundleItem = {
      id: parseInt(variantId),
      quantity: 1,
      properties: {
        "_setId": setId,
        "_Upsell": true,
        "_includeItem": bundleComponentIds,
        "_includeItemHandles": bundleComponentHandles
      }
    };

    // Add bundle name if available
    if (bundleName) {
      bundleItem.properties['_bundle_set_title'] = bundleName;
    }

    // Add discount properties if available
    if (discountData.discountPercentage) {
      bundleItem.properties["_cross_sell_discount_percentage"] = discountData.discountPercentage;
    }

    // Add bundle to cart using same pattern as product-bundle-set.js
    const body = JSON.stringify({
      items: [bundleItem],
      sections: this.cartModal?.getSectionsToRender().map(section => section.id).join(','),
      sections_url: window.location.pathname
    });

    const response = await fetch(`${routes.cart_add_url}`, {...fetchConfig(),...{ body }});

    if (!response.ok) {
      throw new Error('Failed to add bundle to cart');
    }

    const responseData = await response.json();

    if (this.cartModal) {
      this.cartModal.renderContents(responseData, false);
    }

    return responseData;
  }

  initDragScroll() {
    // Use event delegation for drag scrolling on cross-sell lists
    document.addEventListener('mousedown', (e) => {
      const crossSellList = e.target.closest('.cart-cross-sell-list');
      if (!crossSellList) return;

      this.handleDragStart(e, crossSellList);
    });

    // Add touch support
    document.addEventListener('touchstart', (e) => {
      const crossSellList = e.target.closest('.cart-cross-sell-list');
      if (!crossSellList) return;

      this.handleDragStart(e, crossSellList);
    }, { passive: false });
  }

  handleDragStart(e, scrollContainer) {
    // Prevent default drag behavior on images and links
    if (e.target.tagName === 'IMG' || e.target.tagName === 'A'
      || e.target.closest('a') || e.target.closest('button')) {
      return;
    }

    let isDown = false;
    let startX;
    let scrollLeft;
    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let animationId = null;

    const startDrag = (clientX) => {
      isDown = true;
      scrollContainer.classList.add('is-dragging');
      startX = clientX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
      lastX = clientX;
      lastTime = Date.now();
      velocity = 0;

      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
    };

    const stopDrag = () => {
      if (!isDown) return;

      isDown = false;
      scrollContainer.classList.remove('is-dragging');

      // Add momentum scrolling
      if (Math.abs(velocity) > 0.5) {
        const momentum = () => {
          velocity *= 0.95; // Friction
          scrollContainer.scrollLeft -= velocity;

          if (Math.abs(velocity) > 0.5) {
            animationId = requestAnimationFrame(momentum);
          } else {
            animationId = null;
          }
        };
        animationId = requestAnimationFrame(momentum);
      }

      document.removeEventListener('mousemove', moveDrag);
      document.removeEventListener('mouseup', stopDrag);
      document.removeEventListener('mouseleave', stopDrag);
      document.removeEventListener('touchmove', touchMoveDrag);
      document.removeEventListener('touchend', stopDrag);
    };

    const updateScroll = (clientX) => {
      if (!isDown) return;

      const currentTime = Date.now();
      const x = clientX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 1.2; // Reduced multiplier for smoother feel
      const newScrollLeft = scrollLeft - walk;

      // Calculate velocity for momentum
      const deltaX = clientX - lastX;
      const deltaTime = currentTime - lastTime;
      if (deltaTime > 0) {
        velocity = deltaX / deltaTime * 10; // Scale velocity
      }

      scrollContainer.scrollLeft = newScrollLeft;
      lastX = clientX;
      lastTime = currentTime;
    };

    const moveDrag = (e) => {
      e.preventDefault();
      updateScroll(e.clientX);
    };

    const touchMoveDrag = (e) => {
      e.preventDefault();
      if (e.touches.length > 0) {
        updateScroll(e.touches[0].clientX);
      }
    };

    // Handle both mouse and touch events
    if (e.type === 'touchstart') {
      startDrag(e.touches[0].clientX);
      document.addEventListener('touchmove', touchMoveDrag, { passive: false });
      document.addEventListener('touchend', stopDrag);
    } else {
      startDrag(e.clientX);
      document.addEventListener('mousemove', moveDrag);
      document.addEventListener('mouseup', stopDrag);
      document.addEventListener('mouseleave', stopDrag);
    }
  }
}

// Initialize cross-sell manager when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CrossSellManager();
});
